import { useSelector } from 'react-redux'
import { Factory, Globe } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { RootState } from '@/store/store'
import { stringToHexColor } from '@/utils/color'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/utils/cn'
import { IconTile } from '@/components/page/iconTile'
import { paths } from '@/config/paths'

const SidebarHeaderIcon = () => {
  const location = useSelector((state: RootState) => state.location)
  const { pathname } = useLocation()
  const isGlobalMode = pathname.startsWith(paths.admin.root.getHref())

  return (
    <div className="justify-start p-2 m-2 overflow-hidden !opacity-100 min-h-fit border rounded-md">
      <div className={cn('flex items-start space-x-2 text-left flex-1 overflow-hidden white-space-nowrap')}>
        {isGlobalMode ? (
          <IconTile Icon={Globe} color="#60b556" />
        ) : location.name ? (
          <IconTile Icon={Factory} color={stringToHexColor(location.name)} />
        ) : (
          <Skeleton className="h-12 w-12" />
        )}

        <div className="flex-1 overflow-hidden white-space-nowrap">
          {isGlobalMode ? (
            <p className="font-medium">Global Security</p>
          ) : location.name ? (
            <>
              <p className="font-medium truncate">{location.name}</p>
              <p className="text-xs truncate">{location.id}</p>
            </>
          ) : (
            <Skeleton className="w-full h-4 mb-1" />
          )}
          {isGlobalMode ? (
            <p className="text-xs text-muted-foreground leading-none font-semibold truncate">Admin</p>
          ) : location.contactEmail ? (
            <p className="text-xs text-muted-foreground leading-none font-semibold truncate">{location.contactEmail}</p>
          ) : (
            <Skeleton className="w-full h-4" />
          )}
        </div>
      </div>
    </div>
  )
}

export { SidebarHeaderIcon }
